import { render, staticRenderFns } from "./JudgeechoiceModule.vue?vue&type=template&id=daf06602&scoped=true&"
import script from "./JudgeechoiceModule.vue?vue&type=script&lang=js&"
export * from "./JudgeechoiceModule.vue?vue&type=script&lang=js&"
import style0 from "./JudgeechoiceModule.vue?vue&type=style&index=0&id=daf06602&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf06602",
  null
  
)

export default component.exports